import alarmSaga from 'components/Common/Alarm/alarmSaga';
import sidebarSaga from 'components/Common/Sidebar/sidebarSaga';
import homeSaga from 'components/Layout/homeSaga';
import analysisSaga from 'features/Analysis/analysisSaga';
import inverterSaga from 'features/Inverter/inverterSaga';
import authSaga from 'features/Login/authSaga';
import plantSaga from 'features/Plant/plantSaga';
import gatewaySaga from 'features/User/components/GatewayInfo/gatewaySaga';
import ViewerSaga from 'features/User/components/Viewers/ViewerSaga';
import { all } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([
    inverterSaga(),
    authSaga(),
    gatewaySaga(),
    sidebarSaga(),
    homeSaga(),
    plantSaga(),
    ViewerSaga(),
    alarmSaga(),
    analysisSaga(),
  ]);
}
